import ApiClient from './ApiClient';

class ErpGdlCarteirasApi extends ApiClient {
  constructor() {
    super('erp/gdl/carteiras', { accountScoped: true });
  }

  report(params = {}) {
    return window.axios.get(`${this.url}/envios/report`, { params });
  }

  funnel(params = {}) {
    return window.axios.get(`${this.url}/envios/funnel`, { params });
  }

  incompleteData(params = {}) {
    return window.axios.get(`${this.url}/selecao/dados-incompletos`, { params });
  }
}

export default new ErpGdlCarteirasApi();
